<template>
  <div class="batchremove">
    <h3 class="tip">
      <i></i>
      <span>{{$t('msg.m15')}}</span>
    </h3>
    <div>
      <Datatable
        :th="[$t('label.w96'),$t('label.w160'),$t('label.w195'),$t('label.w162')]"
        v-slot="{item}"
        :static="datalist"
        :tip="$t('msg.m101')"
      >
        <tr>
          <td>{{item.Name}}</td>
          <td>{{item.UserOperatorName}}</td>
          <td>{{item.UserOperatorAccount}}</td>
          <td>{{item.UserOperatorVerifyInfo}}</td>
        </tr>
      </Datatable>
    </div>
    <div class="remove">
      <Form label-position="top" ref="form" :model="form" class="removeForm" :rules="formRules">
        <FormItem :label="$t('label.w21')" prop="pwd" class="item">
          <Input type="password" :placeholder="$t('pl.p11')" v-model="form.pwd"/>
          <router-link :to="{name:'security'}">{{$t('nav.w58')}}</router-link>
        </FormItem>
        <FormItem :label="verificationType==1?$t('label.w36'):$t('label.w35')" prop="code" class="item">
          <Row type="flex" :gutter="10" width="360">
            <Col span="17">
              <Input :placeholder="verificationType==1?$t('pl.p2'):$t('pl.p28')" v-model="form.code"/>
            </Col>
            <Col span="7">
              <Codebtn type="SendRelievePledgeCode" :to="verificationType"/>
            </Col>
          </Row>
          <span v-if="verificationType==2" @click="verificationType=1">{{$t('nav.w59')}}</span>
          <span v-if="verificationType==1" @click="verificationType=2">{{$t('nav.w60')}}</span>
        </FormItem>
      </Form>

      <div class="confirm">
        <span @click="back">{{$t('btn.b18')}}</span>
        <span @click="submit">{{$t('btn.b19')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/datatable";
import Codebtn from "@/components/sendCodeButton";
import formRule from "@/libs/formRule";
import Rsa from "@/libs/Rsa";
export default {
  components: { Datatable, Codebtn },
  data() {
    return {
      form: {
        pwd: "",
        code: ""
      },
      formRules:{
        pwd:formRule.pwdUse,
        code:formRule.code
      },
      datalist:[],
      verificationType:2 // 1邮箱 2手机
    };
  },
  mounted(){
    let ids=this.$route.params.ids
    if(ids){
      this.$axios.post('/Member/RZJPledge/SelectBatchPledgeList',{
        pledgeIds:ids
      })
      .then(res=>{
        if(res.err) return this.back()
        this.datalist=res
      })
    }else{
      this.back()
    }
  },
  methods:{
    back(){
      this.$router.replace({name:'domainManage'})
    },
    async submit(){
      let valid = await this.$refs.form.validate();
      if (!valid) return this.$Message.error(this.$t('msg.m62'));
      let res=await this.$axios.post('/Member/RZJPledge/BatchRelievePledge',{
        verificationType:this.verificationType,
        pledgeIds:this.$route.params.ids,
        transactionPassword:Rsa(this.form.pwd),
        code:this.form.code
      })
      res.throw()
      if(!res.err) this.back()
    }
  }
};
</script>

<style lang="less" scoped>
.batchremove {
  .tip {
    display: flex;
    align-items: center;
    margin: 30px 0;
    padding-left: 20px;
    line-height: 40px;
    width: 1200px;
    height: 40px;
    background: rgba(255, 251, 230, 1);
    border-radius: 4px;
    border: 1px solid rgba(255, 229, 143, 1);
    font-size: 14px;
    vertical-align: middle;
    color: rgba(0, 0, 0, 0.85);
    i {
      display: inline-block;
      width: 14px;
      height: 14px;
      background: url("../../assets/security/public_message.png") no-repeat;
      background-size: cover;
      background-position: -14px 0px;
      margin-right: 5px;
    }
  }
  .remove {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    .removeForm {
      display: flex;
      .item {
        width: 360px;
        margin-right: 20px;
        position: relative;
        a {
          position: absolute;
          right: 0;
          top: -27px;
        }
        span{
          position: absolute;
          right: 0;
          top: -27px;
          color: #5E8FFC;
          cursor: pointer;
        }
        /deep/.ivu-form-item-label{
          color: #7B7B7C;
        }
        .ivu-input-wrapper {
          /deep/.ivu-input{
            background: #fff;
          }
        }
      }
    }
  }

  .agree {
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    margin-top: 20px;
    .ivu-checkbox-wrapper {
      margin-right: 0;
      color: rgba(123, 123, 124, 1);
      font-size: 14px;
    }
    span {
      color: #5e8ffc;
      cursor: pointer;
    }
  }
  .confirm {
    span {
      cursor: pointer;
      display: inline-block;
      width: 120px;
      height: 40px;
      border: 1px solid rgba(123, 123, 124, 1);
      border-radius: 20px;
      line-height: 40px;
      color: #7b7b7c;
      font-weight: 500;
      font-size: 16px;
      text-align: center;
    }
    span:last-child {
      background: rgba(94, 143, 252, 1);
      color: rgba(255, 255, 255, 1);
      border-color: #5e8ffc;
      margin-left: 20px;
    }
  }
}
</style>
